import { useEffect, useState } from 'react';
import { Image } from 'react-native';

// Measures a remote image and returns its aspect ratio (height / width).
// Returns null if the image can't be measured.
export const useRemoteImageAspect = (url?: string | null) => {
  const [aspect, setAspect] = useState<number | null>(null);

  useEffect(() => {
    let isMounted = true;
    if (!url) {
      if (isMounted) setAspect(null);
      return () => {
        isMounted = false;
      };
    }
    Image.getSize(
      url,
      (width, height) => {
        if (!isMounted) return;
        if (width > 0) setAspect(height / width);
      },
      () => {
        if (isMounted) setAspect(null);
      }
    );
    return () => {
      isMounted = false;
    };
  }, [url]);

  return aspect;
};


